import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchComments = createAsyncThunk('comments/fetch', async (ticketId) => {
  const { data } = await client.get(`/tickets/${ticketId}/comments/`);
  return { ticketId, comments: data };
});

export const postComment = createAsyncThunk('comments/post', async ({ ticketId, message, files }, { rejectWithValue }) => {
  try {
    let data;
    if (files && files.length > 0) {
      const fd = new FormData();
      fd.append('message', message);
      files.forEach(f => fd.append('files', f));
      ({ data } = await client.post(`/tickets/${ticketId}/comments/`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }));
    } else {
      ({ data } = await client.post(`/tickets/${ticketId}/comments/`, { message }));
    }
    return { ticketId, comment: data };
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

export const updateComment = createAsyncThunk('comments/update', async ({ ticketId, commentId, message, files }, { rejectWithValue }) => {
  try {
    let data;
    if (files && files.length > 0) {
      const fd = new FormData();
      fd.append('message', message);
      files.forEach(f => fd.append('files', f));
      ({ data } = await client.patch(`/tickets/${ticketId}/comments/${commentId}/`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }));
    } else {
      ({ data } = await client.patch(`/tickets/${ticketId}/comments/${commentId}/`, { message }));
    }
    return { ticketId, comment: data };
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

export const deleteComment = createAsyncThunk('comments/delete', async ({ ticketId, commentId }, { rejectWithValue }) => {
  try {
    await client.delete(`/tickets/${ticketId}/comments/${commentId}/`);
    return { ticketId, commentId };
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

const commentsSlice = createSlice({
  name: 'comments',
  initialState: { byTicket: {}, loading: false, posting: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchComments.pending, (state) => { state.loading = true; })
      .addCase(fetchComments.fulfilled, (state, action) => {
        state.loading = false;
        state.byTicket[action.payload.ticketId] = action.payload.comments;
      })
      .addCase(postComment.pending, (state) => { state.posting = true; })
      .addCase(postComment.fulfilled, (state, action) => {
        state.posting = false;
        const { ticketId, comment } = action.payload;
        if (!state.byTicket[ticketId]) state.byTicket[ticketId] = [];
        state.byTicket[ticketId].push(comment);
      })
      .addCase(postComment.rejected, (state) => { state.posting = false; })
      .addCase(updateComment.fulfilled, (state, action) => {
        const { ticketId, comment } = action.payload;
        const list = state.byTicket[ticketId];
        if (list) {
          const idx = list.findIndex(c => c.id === comment.id);
          if (idx !== -1) list[idx] = comment;
        }
      })
      .addCase(deleteComment.fulfilled, (state, action) => {
        const { ticketId, commentId } = action.payload;
        const list = state.byTicket[ticketId];
        if (list) {
          state.byTicket[ticketId] = list.filter(c => c.id !== commentId);
        }
      });
  },
});

export default commentsSlice.reducer;
